import styled from '@bd/bdui-styles/emotion';
import FilterBar from '@bd/bdui-filterbar';
import { colors } from '../styles';

export default styled(FilterBar)`
  position: relative;
  z-index: 1;
  .FilterBar_wrapper {
    width: 100%;
    position: relative;
    z-index: 1;
    @media (min-width: 992px) {
    }
  }
  .FilterBar_list {
    list-style: none;
    padding: 0;
    margin: 0;
    vertical-align: top;
    .FilterBar_listItem {
      display: block;
      font-weight: 800;
      font-size: 16px;
    }
  }
  .FilterSelect_title {
    padding: 0 30px 0 15px;
    cursor: pointer;
    line-height: 45px;
    display: block;
    background-color: #FFFFFF;
    background-image: url('/images/icon-triangle-green.svg');
    background-position: calc(100% - 12px) center;
    background-repeat: no-repeat;
    color: ${colors.color1};
    border-bottom: 1px solid #EEEEEE;
    &:focus {
      outline: none;
    }
  }

  .FilterSelect_wrapper-active .FilterSelect_title {
    background-image: url('/images/icon-triangle-up-green.svg');
  }

  .FilterSelect_dropdown {
    position: relative;
    list-style: none;
    padding: 0 15px;
    background: #FFFFFF;
    border-bottom: 1px solid #EEEEEE;
    @media (min-width: 992px) {
      width: auto;
      min-width: 200px;
    }
  }
  .FilterSelect_dropdownItem {
    font-weight: 300;
    font-size: 16px;
    color: #3F3F3F;
    border-bottom: 1px solid #CFCFCF;
    width: 100%;
    padding: 0 15px;
    &:last-child {
      border: 0;
    }
  }
  .FilterSelect_dropdownItemButton {
    padding: 10px 0;
    display: inline-block;
    cursor: pointer;
    width: calc(100% - 30px);
  }
  .FilterSelect_dropdownItemCheckbox {
    display: inline-block;
    width: 30px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/FilterBar.js